import React from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const SplitLayout = ({ elmFor, bgImage, children }) => {
  const classes = useStyles({ bgImage })

  return (
    <div
      className={clsx(
        classes.container,
        'bg-white',
        elmFor === 'preview' ? 'w-full h-full' : 'w-screen h-screen'
      )}
    >
      <section className="md:w-1/2 h-full bg-white flex justify-center items-center">
        <div className="w-2/3" style={{ maxWidth: 420, minWidth: 350 }}>
          {children}
        </div>
      </section>
    </div>
  )
}

const useStyles = makeStyles(() => ({
  container: ({ bgImage }) => ({
    backgroundImage: `url(${bgImage})`,
    backgroundPosition: '145% 50%',
    backgroundSize: '78% 100%',
    backgroundRepeat: 'no-repeat'
  })
}))

export default SplitLayout
